import type { CardInput, GeneratedCardInfo } from './api';

/**
 * Applique la proposition de « Générer la carte » au formulaire (PUR, testé).
 *
 * Tous les champs générés REMPLACENT la saisie (régénérer = nouvelle
 * proposition complète). Sont conservés : le texte d'origine et les cours
 * associés — sauf si la matière ou les niveaux changent, car la liste des
 * cours proposés en dépend (des cours d'une autre matière ne s'afficheraient
 * plus mais resteraient enregistrés).
 */
export function applyGeneratedCardInfo(input: CardInput, info: GeneratedCardInfo): CardInput {
  const sameLevels =
    info.levels.length === input.levels.length &&
    info.levels.every((l) => input.levels.includes(l));
  const keepLessons = info.subject === input.subject && sameLevels;
  return {
    ...input,
    title: info.title,
    card_type: info.card_type,
    subject: info.subject,
    levels: [...info.levels],
    topic: info.topic,
    domain_label: info.domain_label,
    method: info.method,
    when_to_use: info.when_to_use,
    rule: info.rule,
    example: info.example,
    pitfalls: info.pitfalls,
    xp_max: info.xp_max,
    difficulty: info.difficulty,
    importance: info.importance,
    // Carte dérivée : la rareté est imposée par la parente (+1 étoile).
    rarity: input.parent_card_id ? input.rarity : info.rarity,
    lesson_ids: keepLessons ? input.lesson_ids : [],
  };
}

/** Longueur minimale du texte pour lancer la génération (miroir de la requête serveur). */
export const CARD_SOURCE_TEXT_MIN = 10;
export const CARD_SOURCE_TEXT_MAX = 6000;
